const SEGMENT_KEY = process.env.NEXT_PUBLIC_SEGMENT_MARKETING_KEY;

export let segmentInstance;

export const init = (pageCategory) => {
  if (process.browser) {
    const segment = require('@segment/analytics-next');

    window._axcb = window._axcb || [];
    window._axcb.push((axeptio) => {
      axeptio.on('cookies:complete', (choices) => {
        // Specify only the integrations that might be impacted by the user's choices.
        // Every other integrations will be loaded by default (eg Amplitude, Google Tag Manager, etc.)
        const integrations = {
          'Twitter Ads': choices.twitter,
          'Facebook Pixel': choices.facebook,
          Intercom: choices.intercom,
        };

        segment.AnalyticsBrowser.load(
          {
            writeKey: SEGMENT_KEY,
          },
          {
            integrations,
            disableClientPersistence: !choices.segment,
          }
        ).then((response) => {
          segmentInstance = response[0];
          segmentInstance.page(pageCategory || 'WEBSITE');
          const user = process.browser && localStorage?.user && JSON.parse(localStorage.user);
          if (user?.email) {
            segmentInstance.identify(user.slug, { email: user.email });
          }
        });
      });
    });
  }
};

export const identify = () => {
  const user = process.browser && localStorage?.user && JSON.parse(localStorage.user);
  if (segmentInstance && user?.email) {
    segmentInstance.identify(user.slug, { email: user.email });
  }
};

export const event = (name, { ...properties }) => {
  if (segmentInstance) {
    segmentInstance.track(name, properties);
  }
};

export const page = (category) => {
  if (segmentInstance) {
    segmentInstance.page(category || 'WEBSITE');
  }
};
